import { useMutation } from '@tanstack/react-query';
import type { PaidTier } from '@mondy/shared';
import { api } from '@/api';

/**
 * Kick off a hosted Stripe Checkout flow for a paid tier. Caller is
 * responsible for redirecting the browser to the returned `url` (we don't
 * navigate here so the caller can show optimistic feedback first).
 */
export function useStartCheckout() {
  return useMutation({
    mutationFn: async (tier: PaidTier) => {
      const res = await api.post<{ url: string }>(
        '/api/payments/checkout-session',
        { tier },
      );
      return res;
    },
  });
}
